import { FC, useEffect } from "react";
import { useParams } from "react-router-dom";
import { getBrandDiscountById } from "../../app/services/brandDiscountService";
import { useAppDispatch } from "../../app/hooks";
import { useAccount, useMsal } from "@azure/msal-react";
import { useSelector } from "react-redux";
import { RootState } from "../../app/store";
import Form from "react-bootstrap/Form";
import {
  Accordion,
  Breadcrumb,
  Button,
  Col,
  ListGroup,
  Row,
} from "react-bootstrap";
import moment from "moment";
import "moment/locale/sv";

interface Props {}

const BrandDiscountView: FC<Props> = () => {
  moment.locale("sv");
  const { brandDiscountId } = useParams<{ brandDiscountId: string }>();
  const dispatch = useAppDispatch();

  const { instance, accounts } = useMsal();
  const account = useAccount(accounts[0] || {});

  const brandDiscountData = useSelector(
    (state: RootState) => state.brandDiscount
  );

  useEffect(() => {
    dispatch(getBrandDiscountById(instance, account, brandDiscountId));
  }, [account, accounts, dispatch, instance, brandDiscountId]);
  return (
    <div>
      <Breadcrumb>
        <Breadcrumb.Item href="/brand-discounts">Rabatter</Breadcrumb.Item>
        <Breadcrumb.Item active>{brandDiscountId}</Breadcrumb.Item>
      </Breadcrumb>
      <hr />
      <Form>
        <Row>
          <Col xs={12} md={4}>
            <Form.Group className="mb-3">
              <Form.Label>Bilmärke</Form.Label>
              <Form.Control
                type="text"
                value={brandDiscountData.brandDiscount.carBrand?.name ?? ""}
                readOnly
                disabled
              />
            </Form.Group>
          </Col>
          <Col xs={12} md={4}>
            <Form.Group className="mb-3">
              <Form.Label>VSN</Form.Label>
              <Form.Control
                type="text"
                value={brandDiscountData.brandDiscount.workshopSalesDiscount ?? ""}
                readOnly
                disabled
              />
            </Form.Group>
          </Col>
          <Col xs={12} md={4}>
            <Form.Group className="mb-3">
              <Form.Label>SPN</Form.Label>
              <Form.Control
                type="text"
                value={brandDiscountData.brandDiscount.storeDiscount ?? ""}
                readOnly
                disabled
              />
            </Form.Group>
          </Col>
        </Row>
      </Form>

      <Row>
        <div className="text-end">
          <Button
            variant="primary"
            href={`/brand-discounts/${brandDiscountId}/edit`}
          >
            Redigera
          </Button>
        </div>
      </Row>

      <div className="mt-3">
        <Accordion>
          <Accordion.Item eventKey="0">
            <Accordion.Header>Historik</Accordion.Header>
            <Accordion.Body>
              <ListGroup as="ul">
                <ListGroup.Item as="li">
                  <span>
                    Updaterades senast{" "}
                    {moment
                      .utc(brandDiscountData.brandDiscount.updatedAt)
                      .local()
                      .format("yyyy-MM-DD HH:mm")}
                  </span>
                </ListGroup.Item>
                <ListGroup.Item as="li">
                  <span>
                    Skapades den{" "}
                    {moment
                      .utc(brandDiscountData.brandDiscount.createdAt)
                      .local()
                      .format("yyyy-MM-DD HH:mm")}
                  </span>
                </ListGroup.Item>
              </ListGroup>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </div>
    </div>
  );
};

export default BrandDiscountView;
